import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppComponent } from './app.component';
import { HttpBackend, provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptor } from './interceptors/auth-interceptor';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatRadioModule } from '@angular/material/radio';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { FooWebFrameworkModule } from '@foo/foo-web-framework';
import { SharedModulesModule as WebSharedModulesModule } from '@foo/foo-web-framework/shared-modules';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { DecimalPipe } from "@angular/common";
import { environment } from "../environments/environment";
import { AppConfigService as webConfigService } from '@foo/foo-web-framework';
import { ConfigService } from './services/config/config.service';
import { MenuService as webMenuService } from '@foo/foo-web-framework';
import { LayoutMenuService } from './services/layout-menu/layout-menu.service';
import {ValidationService} from "./services/validation/validation.service";
import { ValidationService as WebValidationService } from '@foo/foo-web-framework/shared-modules/navigation';
import { ConsentsService as WebConsentsService } from '@foo/foo-web-framework/shared-modules/consents';
import {ConsentsService} from "./services/consents/consents.service";
import { AuthService as InternetBankingAuthService } from '@foo/internet-banking-web-framework/modules/auth';
import { AuthService } from './services/auth/auth.service';
import { MenuAccessService as InternetBankingMenuAccessService, Pages } from '@foo/internet-banking-web-framework/shared-core';
import { MenuAccessService } from './menu-access/menu-access.service';
import { DeepLinkRedirectComponent } from './components/deep-link-redirect/deep-link-redirect.component';

@NgModule({
    declarations: [
        AppComponent,
        DeepLinkRedirectComponent,
    ],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatMomentDateModule,
        NgbModule,
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpBackend]
            },
            isolate: true,
            defaultLanguage: (window as any)['lang']
        }),
        NgSelectModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatRadioModule,
        ReactiveFormsModule,
        FormsModule,
        FooWebFrameworkModule.forRoot(environment),
        WebSharedModulesModule.forRoot(),
        BreadcrumbComponent,
        BreadcrumbItemDirective,
        NgxPaginationModule,
        AppRoutingModule,
        MatDialogModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: window['pwa_enabled'],
            scope: window['base_url'] ? `${window['base_url']}/` : '/',
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [
        DecimalPipe,
        {
            provide: webConfigService,
            useClass: ConfigService
        },
        {
            provide: webMenuService,
            useClass: LayoutMenuService
        },
        {
            provide: WebValidationService,
            useClass : ValidationService
        },
        {
            provide: WebConsentsService,
            useClass : ConsentsService
        },
        {
            provide: InternetBankingAuthService,
            useClass: AuthService
        },
        {
            provide: InternetBankingMenuAccessService,
            useClass: MenuAccessService
        },
        provideHttpClient(withInterceptors([AuthInterceptor]), withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }))
    ]
})
export class AppModule {
}

// required for AOT compilation
export function HttpLoaderFactory(_httpBackend: HttpBackend): MultiTranslateHttpLoader {
    return new MultiTranslateHttpLoader(_httpBackend, [
        { prefix: './assets/i18n/', suffix: '.common.json?v=' + Date.now() },
        { prefix: './assets/i18n/', suffix: '.foo-web.json?v=' + Date.now() },
        { prefix: './assets/i18n/', suffix: '.internetbanking.json?v=' + Date.now() },
        { prefix: './assets/i18n/', suffix: '.remittance.json?v=' + Date.now() },
        { prefix: './assets/i18n/', suffix: '.wallet.json?v=' + Date.now() },
        { prefix: './assets/i18n/', suffix: '.json?v=' + Date.now() }
    ]);
}

